export const SERVER = 'prod';
